import { Loadable } from '@shared/interfaces/loadable.interface';
import { PagedContent } from '@shared/interfaces/paged-content.interface';
import get from 'lodash/get';

export class LoadableStateReducerHelper {
  public static startLoad<T>(state: Loadable<T>): Loadable<T> {
    return { ...state, isLoading: true };
  }

  public static startLoadMore<T>(state: Loadable<PagedContent<T>>): Loadable<PagedContent<T>> {
    return { ...state, isLoadingMore: true };
  }

  public static loadSuccess<T>(data: T): Loadable<T> {
    return { data, isLoading: false, isLoadingMore: false };
  }

  public static loadMoreSuccess<T>(state: Loadable<PagedContent<T>>, data: PagedContent<T>): Loadable<PagedContent<T>> {
    return {
      ...state,
      data: {
        ...state.data,
        ...data,
        content: get(state, ['data', 'content'], []).concat(data.content),
      },
      isLoading: false,
      isLoadingMore: false,
    };
  }

  public static loadError<T>(state: Loadable<T>, error?: string): Loadable<T> {
    return { ...state, error, isLoading: false, isLoadingMore: false };
  }
}
